__turbopack_context__.v({
  "active": "AutoCompleteSuggestions-module__YK3dNG__active",
  "blok-big-title": "AutoCompleteSuggestions-module__YK3dNG__blok-big-title",
  "blok-subtitle": "AutoCompleteSuggestions-module__YK3dNG__blok-subtitle",
  "blok-title": "AutoCompleteSuggestions-module__YK3dNG__blok-title",
  "headerText": "AutoCompleteSuggestions-module__YK3dNG__headerText",
  "root": "AutoCompleteSuggestions-module__YK3dNG__root",
  "suggestion": "AutoCompleteSuggestions-module__YK3dNG__suggestion",
  "suggestions": "AutoCompleteSuggestions-module__YK3dNG__suggestions",
});
